const installationInstructions = {
  powerDevice: {
    currentStep: 'powerDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/plug/plug_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.plug.powerDevice.title',
    secondaryTx: 'categories.plug.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'powerDevice',
      titleTx: 'categories.plug.stepsToReset',
    },
  },
  confirmPairingMode: {
    currentStep: 'confirmPairingMode',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/plug/plug_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.plug.confirmPairingMode.title',
    secondaryTx: 'categories.plug.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'confirmPairingMode',
      titleTx: 'categories.plug.stepsToReset',
    },
  },
  resetDevice: {
    headerIcon: 'closeBlack',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    currentStep: 'resetDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.plug.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/categories/plug/reset_power_step_1.png'),
          primaryTx: 'categories.plug.resetDevice.step1.title',
          secondaryTx: 'categories.plug.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/plug/reset_power_step_2.png'),
          primaryTx: 'categories.plug.resetDevice.step2.title',
          secondaryTx: 'categories.plug.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/plug/reset_power_step_3.gif'),
          primaryTx: 'categories.plug.resetDevice.step3.title',
          secondaryTx: 'categories.plug.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
